export const environment = {
  production: false,
  BASEURL: 'https://nest-backend.martinsbbqadmin.com/',
  firebaseConfig: {
    apiKey: 'AIzaSyAdbzj__U1vQmV-YmkEAD4s8NaC37vnwe4',
    authDomain: 'martinbbqtesting.firebaseapp.com',
    projectId: 'martinbbqtesting',
    storageBucket: 'martinbbqtesting.firebasestorage.app',
    messagingSenderId: '365936828150',
    appId: '1:365936828150:web:22afd309d68794f76d56d7',
    measurementId: 'G-M64BBGB8P1',
    vapidKey: 'BMBYvpTwp-TdbA6X2hld88YYD8EVSCI1QGFP-M8zaSl83mQ-yZBzdwwoWpNAG4cNNODisnDBL66SpAMbfzJ5Sk0',
  },
};
